module.exports = __webpack_public_path__ + "img/giftcards.8d069d32.svg";